import React from "react";

function BrowserNavBar() {
    return <div></div>;
}

export default BrowserNavBar;
